import React, { useCallback } from 'react';
import { Typography, Button } from '@mui/material';
import { trackEvent } from '@surfline/web-common';
import { CLICKED_SUBSCRIBE_CTA } from '../../common/constants';

import styles from './PremiumWindStationCTA.module.scss';

interface Props {
  windStationCard?: React.ReactNode | undefined;
  segmentProperties: {
    pageName: string;
  };
}

const DesktopPremiumWindStationCTA: React.FC<Props> = ({ windStationCard, segmentProperties }) => {
  const handleClick = useCallback(
    () =>
      trackEvent(CLICKED_SUBSCRIBE_CTA, {
        ...segmentProperties,
        location: 'wind-station-map',
      }),
    [],
  );
  return (
    <div className={styles.ctaWrapper} data-testid="wind-stations-paywall-container">
      <Typography variant="headline" className="ctaTitle" data-testid="ctaTitle">
        Try Surfline Premium to access real-time wind conditions
      </Typography>
      <div className={styles.buttonWrapper}>
        <Button
          variant="primary"
          className={styles.ctaButton}
          href="/upgrade"
          onClick={handleClick}
          aria-label="premium upgrade link"
          disableFocusRipple
          disableRipple
          disableTouchRipple
          data-testid="ctaButton"
        >
          Upgrade
        </Button>
      </div>
      <div className={styles.paywallWindStation} data-testid="paywallWindStation">
        {windStationCard && windStationCard}
      </div>
    </div>
  );
};

export default DesktopPremiumWindStationCTA;
